import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { useActionState, useEffect } from "react";
import { deleteShoppingCompany } from "../actions";
import toast from "react-hot-toast";

export function CreateShoppingCompany() {
  return (
    <Link to="/admin/shopping-companies/create">
      <Button className="mt-4">
        Add New Company
        <Icon icon={PlusIcon} label="Add New Company" className="ml-1" />
      </Button>
    </Link>
  );
}

export function UpdateShoppingCompany({ id }: { id: string }) {
  return (
    <Link to={`/admin/shopping-companies/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteShoppingCompany({ id }: { id: string }) {
  const navigate = useNavigate();
  const deleteWithId = deleteShoppingCompany.bind(null, id);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this shopping company?")) {
      e.preventDefault();
    }
  }

  const [state, formAction, isPending] = useActionState(deleteWithId, {
    success: false,
  });

  useEffect(() => {
    if (state.success) {
      navigate("/admin/shopping-companies?reload=true", { replace: true });
      toast.success("Shopping company deleted successfully");
    }
  }, [state, navigate]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending} />
    </form>
  );
}
